import { Image, Platform } from 'react-native'
import { useEffect } from 'react'
import { ThemedView, ThemedText, Theme } from '@app/theme'
import Button from '@app/sharedComponents/Button/Button'
import LottieView from "lottie-react-native";

const DspAgreementSuccessModal = ({ onPress }: { onPress: () => void }) => {

    useEffect(() => {
        if (onPress) {
            const timer = setTimeout(() => {
                onPress()
            }, 5000)
            return () => clearTimeout(timer)
        }
    }, [onPress])


    return (
        <ThemedView justifyContent='center' alignItems='center' padding='lg' bg='bg-surface-primary'>
            {Platform.OS === 'web' ? (
                <Image
                    source={{ uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/StatusSuccess_1.svg' }}
                    style={{ width: 48, height: 48 }}
                />
            ) : (
                <LottieView
                    source={{ uri: "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json" }}
                    style={{ width: 70, height: 70 }}
                    autoPlay={true}
                    loop={true}
                />
            )}
            <ThemedText mt='md' variant='h5s' color='text-primary'>Agreement signed successfully!</ThemedText>
            <ThemedText mt='xs' mb='md' variant='b3r' color='text-secondary'>You will be redirected to next step in few seconds</ThemedText>
            <Button size='MD' type='OUTLINED' label='Continue' handlePress={onPress} bg='#1434CB' textColor='text-primary' />

        </ThemedView>
    )
}

export default DspAgreementSuccessModal